import React from "react"

const Card = () => {
  return <div>{"card"}</div>
}

export { Card }
